module.exports = __webpack_public_path__ + "img/chevron-up-16px-light.6d6d89d.svg";